function initQuickViewScripts(scope = document) {
  const modal = document.getElementById('quick-view-modal');
  const modalContent = document.getElementById('quick-view-data');
  const sideCart = document.querySelector('side-cart');

  // const formatPrice = (cents) => {
  //   try {
  //     if (window.Shopify && typeof Shopify.formatMoney === 'function') {
  //       return Shopify.formatMoney(cents);
  //     }
  //     const v = Number(cents) / 100;
  //     if (isNaN(v)) return '0.00';
  //     return v.toFixed(2);
  //   } catch (e) {
  //     const v = Number(cents) / 100;
  //     if (isNaN(v)) return '0.00';
  //     return v.toFixed(2);
  //   }
  // };
// const shopCurrency = window?.Shopify?.currency?.active || '{{ shop.currency }}'; 
//   // Shopify se current currency le lega

//   const formatPrice = (cents) => {
//     try {
//       const v = Number(cents) / 100;
//       if (isNaN(v)) return '0.00';
//       return new Intl.NumberFormat('en-US', {
//         style: 'currency',
//         currency: shopCurrency, // INR, USD, EUR etc.
//       }).format(v);
//     } catch (e) {
//       const v = Number(cents) / 100;
//       if (isNaN(v)) return '0.00';
//       return v.toFixed(2) + ' ' + shopCurrency;
//     }
//   };
const shopCurrency = window?.Shopify?.currency?.active || '{{ shop.currency }}'; 

const formatPrice = (cents) => {
  try {
    const v = Number(cents) / 100;
    if (isNaN(v)) return '0.00';

    // ✅ Special condition for DKK
    if (shopCurrency === "DKK") {
      // Manual formatting: 6,250.00 kr
      const parts = v.toFixed(2).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","); // thousand separator
      return parts.join(".") + " kr";
    }

    // ✅ For other currencies use Intl formatter
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: shopCurrency, // INR, USD, EUR, etc.
    }).format(v);

  } catch (e) {
    const v = Number(cents) / 100;
    if (isNaN(v)) return '0.00';
    return v.toFixed(2) + ' ' + shopCurrency;
  }
};


// const formatPrice = (cents) => {
//   try {
//     if (window.Shopify && typeof Shopify.formatMoney === 'function') {
//       // Show currency symbol + code (example: ₹1,299.00 INR)
//       return Shopify.formatMoney(cents, "{{amount_with_currency}}");
//     }
//     const v = Number(cents) / 100;
//     if (isNaN(v)) return '0.00';
//     return v.toFixed(2);
//   } catch (e) {
//     const v = Number(cents) / 100;
//     if (isNaN(v)) return '0.00';
//     return v.toFixed(2);
//   }
// };


  // Check variant availability
  const isVariantAvailable = (product, selectedOptions) => {
    const matchedVariant = product.variants.find(
      v => JSON.stringify(v.options) === JSON.stringify(selectedOptions)
    );
    return matchedVariant ? matchedVariant.available : false;
  };

  // Update button states
  const updateButtonStates = (product, currentSelectedOptions) => {
    const variantButtons = modalContent.querySelectorAll('.quick-view-form input[type="radio"]');

    variantButtons.forEach(input => {
      const span = input.nextElementSibling;
      const optionIndex = parseInt(input.name.replace('option-', '')) - 1;

      const testOptions = [...currentSelectedOptions];
      testOptions[optionIndex] = input.value;

      const isAvailable = isVariantAvailable(product, testOptions);

      if (isAvailable) {
        span.classList.remove('disabled');
        input.disabled = false;
      } else {
        span.classList.add('disabled');
        input.disabled = true;
      }
    });
  };

  // Attach click event to all Quick View buttons inside scope
  scope.querySelectorAll('.quick-view-btn').forEach(button => {
    button.addEventListener('click', function () {
      const handle = this.getAttribute('data-product-handle');

      fetch(`/products/${handle}.js`)
        .then(res => res.json())
        .then(product => {
          // ---- Generate Variant Groups ----
          let variantsHTML = '';
          if (product.options.length === 1 && product.options[0].name === 'Title') {
            variantsHTML = `<input type="hidden" name="id" value="${product.variants[0].id}">`;
          } else {
            product.options.forEach((option, optionIndex) => {
              variantsHTML += `
                <div class="variant-option">
                  <div class="variant-option-title">
                    ${option.name}: <span class="selected-value"></span>
                  </div>
                  <div class="variant-buttons">
                    ${[...new Set(product.variants.map(v => v.options[optionIndex]))]
                      .map(
                        value => `
                        <label>
                          <input type="radio" 
                            name="option-${optionIndex + 1}" 
                            value="${value}">
                          <span>${value}</span>
                        </label>
                      `
                      )
                      .join('')}
                  </div>
                </div>
              `;
            });
            variantsHTML += `<input type="hidden" name="id" class="selected-variant-id" value="${product.variants[0].id}">`;
          }

          // ---- Generate Images ----
          let mainSlides = '';
          let thumbSlides = '';
          product.images.forEach(img => {
            const imgId = img.split('/').pop();
            mainSlides += `<div class="swiper-slide"><img src="${img}" alt="${product.title}" data-image-id="${imgId}"></div>`;
            thumbSlides += `<div class="swiper-slide"><img src="${img}" alt="${product.title}" data-image-id="${imgId}"></div>`;
          });

          // ---- Initial price/compare/discount ----
          const initPriceHTML = () => {
            const v = product.variants[0];
            const hasCompare = v.compare_at_price && v.compare_at_price > v.price;
            const discount = hasCompare ? Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) : 0;
            return `
              <div class="price">
                <span class="price-item price-item--regular" style="${hasCompare ? '' : 'display:none'}">${formatPrice(v.compare_at_price)}</span>
                <span class="price-item price-item--sale price-item--last">${formatPrice(v.price)}</span>
                <span class="main-product-badge" style="${hasCompare ? 'display:inline' : 'display:none'}">Spar ${discount}%</span>
              </div>
            `;
          };

          // ---- Inject Modal HTML ----
          modalContent.innerHTML = `
            <span class="quick-view-close">&times;</span>
            <div class="quick-view-content">
              <div class="quick-view-image">
                <div class="swiper main-slider">
                  <div class="swiper-wrapper">${mainSlides}</div>
                </div>
                <div class="swiper thumbnail-slider">
                  <div class="swiper-wrapper">${thumbSlides}</div>
                </div>
              </div>
              <div class="quick-view-details">
                <h2 class="quick-view-title">${product.title}</h2>
                <div class="quick-view-price">${initPriceHTML()}</div>
                <div class="quick-view-description">${product.description}</div>
                <form method="post" action="/cart/add" class="quick-view-form product-form">
                  ${variantsHTML}
                  <button type="submit" class="quick-view-add-to-cart-btn add-to-cart-btn">
                    ${product.available ? 'Add to Cart' : 'Sold Out'}
                  </button>
                </form>
              </div>
            </div>
          `;

          modal.style.display = 'flex';

          // ---- Init Swipers ----
          const thumbSlider = new Swiper('.quick-view-image .thumbnail-slider', {
            spaceBetween: 10,
            slidesPerView: 'auto',
            autoHeight: true,
          });
          const mainSlider = new Swiper('.quick-view-image .main-slider', {
            spaceBetween: 10,
            autoHeight: true,
            slidesPerView: 'auto',
            thumbs: { swiper: thumbSlider },
          });

          // ---- Variant Handling ----
          let currentVariant = product.variants[0];
          const updateQuickView = () => {
            let selectedOptions = [];
            modalContent.querySelectorAll('[name^="option-"]:checked').forEach(input => {
              selectedOptions.push(input.value);
              const wrapper = input.closest('.variant-option');
              if (wrapper) wrapper.querySelector('.selected-value').innerText = input.value;
            });

            const matchedVariant = product.variants.find(
              v => JSON.stringify(v.options) === JSON.stringify(selectedOptions)
            );
            if (!matchedVariant) return;
            currentVariant = matchedVariant;

            const hiddenInput = modalContent.querySelector('.selected-variant-id');
            if (hiddenInput) hiddenInput.value = currentVariant.id;

            // Update price, compare, discount
            const regularEl = modalContent.querySelector('.quick-view-price .price-item--regular');
            const saleEl = modalContent.querySelector('.quick-view-price .price-item--sale');
            const badgeEl = modalContent.querySelector('.quick-view-price .main-product-badge');

            if (saleEl) saleEl.innerText = formatPrice(currentVariant.price);

            if (regularEl && currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
              regularEl.style.display = '';
              regularEl.innerText = formatPrice(currentVariant.compare_at_price);
              const disc = Math.round(((currentVariant.compare_at_price - currentVariant.price) / currentVariant.compare_at_price) * 100);
              if (badgeEl) { badgeEl.style.display = 'inline'; badgeEl.innerText = `Spar ${disc}%`; }
            } else {
              if (regularEl) regularEl.style.display = 'none';
              if (badgeEl) badgeEl.style.display = 'none';
            }

            const btn = modalContent.querySelector('.quick-view-add-to-cart-btn');
            if (!currentVariant.available) {
              btn.setAttribute('disabled', '');
              btn.innerText = 'Sold Out';
            } else {
              btn.removeAttribute('disabled');
              btn.innerText = 'Add to Cart';
            }

            if (currentVariant.featured_image) {
              const imgId = currentVariant.featured_image.src.split('/').pop();
              const index = Array.from(modalContent.querySelectorAll('.main-slider img')).findIndex(
                img => img.dataset.imageId == imgId
              );
              if (index >= 0) mainSlider.slideTo(index);
            }

            updateButtonStates(product, selectedOptions);
          };

          modalContent.querySelectorAll('[name^="option-"]').forEach(input => {
            input.addEventListener('change', updateQuickView);
          });

          modalContent.querySelectorAll('.variant-option').forEach(opt => {
            const firstInput = opt.querySelector('input');
            if (firstInput) firstInput.checked = true;
          });
          if (product.options.length > 1 || product.options[0].name !== 'Title') {
            updateQuickView();
          }

          // ---- Add to cart ----
          modalContent.querySelector('.quick-view-form').addEventListener('submit', function (e) {
            e.preventDefault();
            const formData = new FormData(this);
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
              body: formData,
            })
              .then(res => res.json())
              .then(() => {
                modal.style.display = 'none';
                if (sideCart && typeof sideCart.getCart === 'function') {
                  sideCart.getCart();
                  if (sideCart.drawer && typeof sideCart.drawer.open === 'function') {
                    sideCart.drawer.open();
                  }
                }
              })
              .catch(err => console.error(err));
          });

          // ---- Close modal ----
          modalContent.querySelector('.quick-view-close').addEventListener('click', () => (modal.style.display = 'none'));
          modal.addEventListener('click', e => {
            if (e.target === modal) modal.style.display = 'none';
          });
        });
    });
  });
}

// ✅ Init once on page load
document.addEventListener("DOMContentLoaded", function () {
  initQuickViewScripts(document);
});
